import { useBuilder } from "../BuilderContext";
import { VibesTab } from "./VibesTab";
import { ActsTab } from "./ActsTab";

/**
 * What guests choose from.
 *
 * Vibes and Acts answer the same question — "what are the options?" — and were
 * two tabs. Worse, Acts stayed in the tab bar even when the participant screen
 * was switched off, so operators filled in a list of clubs for a booth that
 * would never show it.
 *
 * Now they're one tab, and Acts is only rendered when the participant screen is
 * actually part of the flow. A tab should not offer to configure a screen that
 * doesn't exist.
 */
export function ContentTab() {
  const { draft } = useBuilder();
  const skipParticipants = draft.workflow?.skip_participants ?? false;

  return (
    <div className="flex flex-col gap-8">
      <VibesTab />

      {skipParticipants ? (
        <p className="rounded-lg border border-ink-600 bg-ink-800/60 px-4 py-3 text-xs leading-relaxed text-haze-400">
          The participant screen is switched off for this event, so there are no
          acts to configure. Turn it back on in the <strong className="text-accent">Flow</strong> tab
          if guests should pick a club, stage or side.
        </p>
      ) : (
        <ActsTab />
      )}
    </div>
  );
}
